import BugReportIcon from '@mui/icons-material/BugReport';
import GoogleIcon from '@mui/icons-material/Google';

export type AuthProvider = {
  name: string;
  description: string;
  icon: React.ReactNode;
  href: string;
};

export const AUTH_PROVIDERS: Record<string, AuthProvider> = {
  google: {
    name: 'google',
    description: 'Se connecter avec Google',
    icon: <GoogleIcon />,
    href: 'https://accounts.google.com',
  },
  ...(process.env.NEXT_PUBLIC_AUTH_MOCK_ENABLED === 'true'
    ? {
        'mock-oidc': {
          name: 'mock-oidc',
          description: 'Connexion développeur',
          icon: <BugReportIcon />,
          href:
            process.env.AUTH_MOCK_OIDC_ISSUER ??
            'http://mock-oidc-provider:9400',
        },
      }
    : {}),
};
